import actions from './wizardActions'
import mutations from './wizardMutations'

export default {
  namespaced: true,
  actions,
  mutations
}